import { Color, FontType, Align } from '@americanexpress/aqx-components';

const summitTitleTheme = {
  color: Color.DeepBlue,
  textAlign: Align.Left,
  marginBottom: 15,
  fontType: FontType.HelveticaBold
};

const summitTitleThemeTablet = {
  color: Color.DeepBlue,
  textAlign: Align.Left,
  marginBottom: 5,
  fontType: FontType.HelveticaBold
};

const summitHeroCustomization = {
  heroTitle: {
    htmlTag: 'h1',
    fontSizes: {
      sm: 20,
      md: 20,
      lg: 20
    },
    themes: {
      sm: summitTitleTheme,
      md: summitTitleTheme,
      lg: summitTitleTheme
    }
  }
};

const summitTabContentPanelTheme = {
  marginRight: 10
};

const summitTabContentTitleTheme = {
  ...summitTitleThemeTablet,
  color: Color.DeepBlue,
  fontType: FontType.BentonBold
};

const summitTabContentTextTheme = {
  ...summitTabContentTitleTheme,
  color: Color.Gray06,
  fontType: FontType.HelveticaRegular
};

const summitTabContentCustomization = {
  contentPanel: {
    themes: {
      sm: { marginTop: 0, marginRight: 0 },
      md: summitTabContentPanelTheme,
      lg: summitTabContentPanelTheme
    }
  },
  tabContentTitle: {
    htmlTag: 'h2',
    fontSizes: {
      sm: 20,
      md: 20,
      lg: 20
    },
    themes: {
      sm: summitTabContentTitleTheme,
      md: summitTabContentTitleTheme,
      lg: summitTabContentTitleTheme
    }
  },
  tabContentText: {
    htmlTag: 'div',
    fontSizes: {
      sm: 15,
      md: 15,
      lg: 15
    },
    themes: {
      sm: summitTabContentTextTheme,
      md: summitTabContentTextTheme,
      lg: summitTabContentTextTheme
    }
  },
  learnMoreCta: {
    themes: {
      sm: { marginBottom: 10, marginTop: 10 },
      md: { marginRight: 10 },
      lg: { marginRight: 10 }
    }
  }
};

export { summitHeroCustomization, summitTabContentCustomization };
